import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useRouteMatch,
  useLocation,
  Redirect,
} from "react-router-dom";
import { PDFViewer } from "@react-pdf/renderer";
import Login from "../components/Login/Login";
import PrivateRoute from "./PrivateRoute";
import SideBar from "../components/SideBar";
import Dashboard from "../../CRM/components/Dashboard/Dashboard";
import Clients from "../../CRM/components/Clients/Clients";
import ClientAdd from "../../CRM/components/Clients/ClientAdd";
import EditClient from "../../CRM/components/Clients/EditClient";
import Tasks from "../../CRM/components/Tasks/Tasks";
import Contract from "../../CRM/components/Tasks/Contract";
import Remision from "../../Centro_Logistico/components/Logistics/Remision";
import Quote from "../../CRM/components/Quote/Quote";
import Search from "../../CRM/components/Search/Search";
import Contacts from "../../CRM/components/Contacts/Contacts";
import { Quote_pdf } from "../../CRM/components/Quote/Quote_pdf";
import { Dashboard as Dashboard_centro_log } from "../../Centro_Logistico/components/Dashboard/Dashboard";
import Entrances from "../../Centro_Logistico/components/Entrances/Entrances";
import Entrance_Detail from "../../Centro_Logistico/components/Entrances/Entrance_Detail";
import Logistics from "../../Centro_Logistico/components/Logistics/Logistics";
import Movements from "../../Centro_Logistico/components/Movements/Movements";
import Stock from "../../Centro_Logistico/components/Stock/Stock";
import Tester from "../components/shared/Tester.js";
import { Search as Search_centro_log } from "../../Centro_Logistico/components/Search/Search";
import { Dashboard as Dashboard_inventario } from "../../Inventario/components/Dashboard/Dashboard";
import Inputs from "../../Inventario/components/Inputs/Inputs";
import InputsPo from "../../Inventario/components/Inputs/InputsPo";
import InputsPoDetail from "../../Inventario/components/Inputs/InputsPoDetail";
import InputsReturn from "../../Inventario/components/Inputs/InputsReturn";
import Outputs from "../../Inventario/components/Outputs/Outputs";
import { Stock as Stock_inventario } from "../../Inventario/components/Stock/Stock";
import Tools from "../../Inventario/components/Tools/Tools";
import Home from "../../Pedidos/components/Home/Home";
import Detail_order from "../../Pedidos/components/Home/Detail_order";
import { Dashboard as Dashboard_purchase } from "../../Compras/components/Dashboard/Dashboard";
import { InputsPurchase } from "../../Compras/components/Inputs_Purchase/inputs_purchase";
import { InputsPurchaseDetail } from "../../Compras/components/Inputs_Purchase/input_purchase_detail";
import { Orders_manager } from "../../Compras/components/Orders_manager/orders_manager";
import { GroupManagement } from "../../Compras/components/Orders_manager/group_management";
import { Stock as Stock_purchase } from "../../Compras/components/Stock/Stock";
import { SuppliersManagement } from "../../Compras/components/Suppliers/SuppliersManagemet";
import { Suppliers as SuppliersPurchase } from "../../Compras/components/Suppliers/Suppliers";
import { Branches } from "../../Compras/components/Suppliers/Branches";
import { Contacts as SupplierContacts } from "../../Compras/components/Suppliers/Contacts";
import { SupplierOrderDetail } from "../../Compras/components/Suppliers_orders/SupplierOrderDetail";
import Suppliers_orders from "../../Compras/components/Suppliers_orders/Suppliers_orders";
import { useDataLayerValue } from "../reducer/DataLayer";
import Bill_Account from "../../CRM/components/Tasks/Bill_Account"
import {PoPdf} from "../../Compras/components/Suppliers_orders/poPdf"
import {OrderPdf} from "../../Pedidos/components/Home/OrderPdf.js"
import BillOfMaterials from "../../Pedidos/components/BillOfMaterials/BillOfMaterials";
import BillOfMaterialsList from "../../Pedidos/components/BillOfMaterials/BillOfMaterialsList";
import BomProductsList from "../../Pedidos/components/BillOfMaterials/BomProductsList";

import {
  init_crm_location,
  url_crm_dashboard,
  url_crm_clients,
  url_crm_contacts,
  url_crm_tasks,
  url_crm_quote,
  url_crm_search,
} from "../../CRM/constants/constants";
import {
  init_centro_log_location,
  url_centro_log_dashboard,
  url_centro_log_entrances,
  url_centro_log_logistics,
  url_centro_log_movements,
  url_centro_log_search,
  url_centro_log_stock,
} from "../../Centro_Logistico/constants/constants";
import {
  init_inventario_location,
  url_inventario_dashboard,
  url_inventario_inputs,
  url_inventario_outputs,
  url_inventario_stock,
  url_inventario_tools,
} from "../../Inventario/constants/constants";
import {
  init_orders_location,
  url_orders_home,
  url_bill_of_materials,
  url_bom_products,
} from "../../Pedidos/constants/constants";
import {
  init_purchase_location,
  url_purchase_dashboard,
  url_purchase_inputs,
  url_purchase_orders_manager,
  url_purchase_suppliers_orders,
  url_purchase_stock,
  url_purchase_suppliers,
} from "../../Compras/constants/constants";
import UserConfig from "../../App/components/UserConfig/UserConfig";
import { ModalFetch } from "../components/shared/Modals";

function Routes() {
  const [{ error_fetching }, dispatch] = useDataLayerValue();
  const onCloseModalFetch = () => {
    dispatch({
      type: "SET_ERROR_FETCH",
      error_fetching: false,
    });
  };

  return (
    <Switch>
      <Route path="/log/:module">
        <Tester />
        <Login />
      </Route>
      <PrivateRoute path={init_crm_location}>
        <Tester />

        <div className="screen">
          <SideBar />
          <div className="content">
            <Switch>
              <Redirect exact from={init_crm_location} to={url_crm_dashboard} />
              <Route path={url_crm_dashboard}>
                <Dashboard />
              </Route>
              <Route path={url_crm_clients}>
                <Switch>
                  <Route exact path={url_crm_clients}>
                    <Clients />
                  </Route>
                  <Route path={`${url_crm_clients}/clientadd`}>
                    <ClientAdd />
                  </Route>
                  <Route path={`${url_crm_clients}/edit_client`}>
                    <EditClient />
                  </Route>
                </Switch>
              </Route>
              <Route path={url_crm_contacts}>
                <Contacts />
              </Route>
              <Route path={url_crm_tasks}>
                <Tasks />
              </Route>
              <Route path={url_crm_quote}>
                <Quote />
              </Route>
              <Route path={url_crm_search}>
                <Search />
              </Route>
            </Switch>
          </div>
        </div>
      </PrivateRoute>
      <PrivateRoute path={init_centro_log_location}>
        <Tester />

        <div className="screen">
          <SideBar />
          <div className="content">
            <Switch>
              <Redirect
                exact
                from={init_centro_log_location}
                to={url_centro_log_dashboard}
              />
              <Route path={url_centro_log_dashboard}>
                <Switch>
                  <Route exact path={url_centro_log_dashboard}>
                    <Dashboard_centro_log />
                  </Route>
                  <Route path={`${url_centro_log_dashboard}/userconfig`}>
                    <UserConfig module="centro_log" />
                  </Route>
                </Switch>
              </Route>
              <Route path={url_centro_log_entrances}>
                <Switch>
                  <Route exact path={url_centro_log_entrances}>
                    <Entrances />
                  </Route>
                  <Route path={`${url_centro_log_entrances}/:id_quote`}>
                    <Entrance_Detail />
                  </Route>
                </Switch>
              </Route>
              <Route path={url_centro_log_logistics}>
                <Logistics />
              </Route>
              <Route path={url_centro_log_movements}>
                <Movements />
              </Route>
              <Route path={url_centro_log_stock}>
                <Stock />
              </Route>
              <Route path={url_centro_log_search}>
                <Search_centro_log />
              </Route>
            </Switch>
          </div>
        </div>
      </PrivateRoute>
      <PrivateRoute path={init_inventario_location}>
        <Tester />
        <div className="screen">
          <SideBar />
          <div className="content">
            <ModalFetch
              open={error_fetching}
              onClose={() => onCloseModalFetch()}
              fetchSuccess={false}
            />
            <Switch>
              <Redirect
                exact
                from={init_inventario_location}
                to={url_inventario_dashboard}
              />
              <Route path={url_inventario_dashboard}>
                <Switch>
                  <Route exact path={url_inventario_dashboard}>
                    <Dashboard_inventario />
                  </Route>
                  <Route path={`${url_inventario_dashboard}/userconfig`}>
                    <UserConfig module="inventario" />
                  </Route>
                </Switch>
              </Route>
              <Route path={url_inventario_inputs}>
                <Route exact path={url_inventario_inputs}>
                  <Inputs />
                </Route>
                <Route exact path={`${url_inventario_inputs}/po`}>
                  <InputsPo />
                </Route>
                <Route path={`${url_inventario_inputs}/po/:poId`}>
                  <InputsPoDetail />
                </Route>
                <Route path={`${url_inventario_inputs}/return`}>
                  <InputsReturn />
                </Route>
              </Route>
              <Route path={url_inventario_outputs}>
                <Outputs />
              </Route>
              <Route path={url_inventario_stock}>
                <Stock_purchase />
              </Route>
              <Route path={url_inventario_tools}>
                <Tools />
              </Route>
            </Switch>
          </div>
        </div>
      </PrivateRoute>
      <PrivateRoute path={init_orders_location}>
        <Tester />
        <div className="screen">
          <SideBar />
          <div className="content">
            <ModalFetch
              open={error_fetching}
              onClose={() => onCloseModalFetch()}
              fetchSuccess={false}
            />
            <Switch>
              <Redirect
                exact
                from={init_orders_location}
                to={url_orders_home}
              />
              <Route exact path={url_orders_home}>
                <Home />
              </Route>
              <Route exact path={`${url_orders_home}/userconfig`}>
                <UserConfig module="orders" />
              </Route>
              <Route path={`${url_orders_home}/:id_order`}>
                <Detail_order />
              </Route>
              <Route exact path={url_bill_of_materials}>
                <BillOfMaterialsList />
              </Route>
              <Route path={`${url_bill_of_materials}/detail`}>
                <BillOfMaterials />
              </Route>
              <Route exact path={url_bom_products}>
                <BomProductsList />
              </Route>
            </Switch>
          </div>
        </div>
      </PrivateRoute>
      <PrivateRoute path={init_purchase_location}>
        <Tester />
        <div className="screen">
          <SideBar />
          <div className="content">
            <ModalFetch
              open={error_fetching}
              onClose={() => onCloseModalFetch()}
              fetchSuccess={false}
            />
            <Switch>
              <Redirect
                exact
                from={init_purchase_location}
                to={url_purchase_dashboard}
              />
              <Route path={url_purchase_dashboard}>
                <Switch>
                  <Route exact path={url_purchase_dashboard}>
                    <Dashboard_purchase />
                  </Route>
                  <Route path={`${url_purchase_dashboard}/userconfig`}>
                    <UserConfig module="purchase" />
                  </Route>
                </Switch>
              </Route>
              <Route path={url_purchase_inputs}>
                <Route exact path={url_purchase_inputs}>
                  <InputsPurchase />
                </Route>
                <Route path={`${url_purchase_inputs}/:id_order`}>
                  <InputsPurchaseDetail />
                </Route>
              </Route>
              <Route path={url_purchase_orders_manager}>
                <Route exact path={url_purchase_orders_manager}>
                    <Orders_manager />
                </Route>
                <Route path={`${url_purchase_orders_manager}/:id_order`}>
                  <GroupManagement />
                </Route>
              </Route>
              <Route path={url_purchase_suppliers_orders}>
                <Route exact path={url_purchase_suppliers_orders}>
                    <Suppliers_orders />
                  </Route>
                  <Route path={`${url_purchase_suppliers_orders}/:id_order`}>
                    <SupplierOrderDetail />
                  </Route>
              </Route>
              <Route path={url_purchase_stock}>
                <Stock_purchase />
              </Route>
              <Route path={url_purchase_suppliers}>
                <Route exact path={url_purchase_suppliers}>
                  <SuppliersManagement />
                </Route>
                <Route path={`${url_purchase_suppliers}/supplier-add`}>
                  <SuppliersPurchase />
                </Route>
                <Route path={`${url_purchase_suppliers}/supplier/:editSupplierId`}>
                  <SuppliersPurchase />
                </Route>
                <Route path={`${url_purchase_suppliers}/branch-add`}>
                  <Branches />
                </Route>
                <Route path={`${url_purchase_suppliers}/branch/:editBranchId`}>
                  <Branches />
                </Route>
                <Route path={`${url_purchase_suppliers}/contacts-add`}>
                  <SupplierContacts />
                </Route>
                <Route path={`${url_purchase_suppliers}/contacts/:editContactId`}>
                  <SupplierContacts />
                </Route>
              </Route>
            </Switch>
          </div>
        </div>
      </PrivateRoute>

      {/* <Route path="/pdf">
        <div style={{ width: "100vw", height: "100vh" }}>
          <PDFViewer width="100%" height="100%">
            <Bill_Account
              values_form={{
                client_name: "Tabcoda_Pruebas",
                nit: "123456789",
                valor_canon_mes: 7314000,
                valor_deposito: 5119800,
                fecha_firma: "2022-02-17",
                municipio: "AbriaquÃ­",
                camara_comercio: "Abriaquí",
                representante_legal: "111",
                id_representante_legal: 111,
                ciudad: "1111",
                ciudad_firma: "Amalfi",
                cuenta_cobro: "111",
              }}
              data_detail={[
                {
                  item: "Alquiler",
                  tipo: "40 Ft HC",
                  producto: "Bodega",
                  descripcion:
                    "Alquiler de contenedor marÃ­timo de 40 pies.\n\nTipo Bodega.\n\nValor mes.\n\nTiempo mÃ­nimo de alquiler: 6 meses.",
                  cant: 1,
                  valorUnit: 639000,
                  valorBruto: 639000,
                  dcto: 0,
                  iva: 19,
                  valorTotal: 760410,
                },
                {
                  item: "Alquiler",
                  tipo: "40 Ft HC",
                  producto: "Bodega",
                  descripcion:
                    "Alquiler de contenedor marÃ­timo de 40 pies.\n\nTipo Bodega.\n\nValor mes.\n\nTiempo mÃ­nimo de alquiler: 6 meses.",
                  cant: 1,
                  valorUnit: 639000,
                  valorBruto: 639000,
                  dcto: 0,
                  iva: 19,
                  valorTotal: 760410,
                },
                {
                  item: "Alquiler",
                  tipo: "20 Ft",
                  producto: "Oficina Tipo A",
                  descripcion:
                    "Alquiler de contenedor marÃ­timo de 20 pies.\nTipo oficina sin recubrimiento.\n\nIncluye: Red elÃ©ctrica expuesta en tuberÃ­a EMT con 1 tablero de 6 circuitos, 1 toma VCP 220 V para acometida principal, 1 toma sencillo a 220 V, 4 tomas dobles a 110 V, 1 salida para voz y datos, 1 aire acondicionado de 12.000 BTU R410 a 220 V, iluminaciÃ³n con 2 lÃ¡mparas hermÃ©ticas de 2x32W y 1 interruptor sencillo. Recubrimiento en piso en vinilo PVC de alto trÃ¡fico, 1 puerta peatonal con chapa de seguridad y 2 ventanas corredizas de 1.00 x 1.00 m. Pintura en anticorrosivo para interior y exterior.\n\nValor mensual.\n\nTiempo mÃ­nimo de alquiler: 30 dÃ­as.",
                  cant: 8,
                  valorUnit: 580000,
                  valorBruto: 4640000,
                  dcto: 0,
                  iva: 19,
                  valorTotal: 5521600,
                },
                {
                  item: "Alquiler",
                  tipo: "20 Ft",
                  producto: "Oficina Tipo A",
                  descripcion:
                    "Alquiler de contenedor marÃ­timo de 20 pies.\nTipo oficina sin recubrimiento.\n\nIncluye: Red elÃ©ctrica expuesta en tuberÃ­a EMT con 1 tablero de 6 circuitos, 1 toma VCP 220 V para acometida principal, 1 toma sencillo a 220 V, 4 tomas dobles a 110 V, 1 salida para voz y datos, 1 aire acondicionado de 12.000 BTU R410 a 220 V, iluminaciÃ³n con 2 lÃ¡mparas hermÃ©ticas de 2x32W y 1 interruptor sencillo. Recubrimiento en piso en vinilo PVC de alto trÃ¡fico, 1 puerta peatonal con chapa de seguridad y 2 ventanas corredizas de 1.00 x 1.00 m. Pintura en anticorrosivo para interior y exterior.\n\nValor mensual.\n\nTiempo mÃ­nimo de alquiler: 30 dÃ­as.",
                  cant: 8,
                  valorUnit: 580000,
                  valorBruto: 4640000,
                  dcto: 0,
                  iva: 19,
                  valorTotal: 5521600,
                },
                {
                  item: "Alquiler",
                  tipo: "20 Ft",
                  producto: "Oficina Tipo A",
                  descripcion:
                    "Alquiler de contenedor marÃ­timo de 20 pies.\nTipo oficina sin recubrimiento.\n\nIncluye: Red elÃ©ctrica expuesta en tuberÃ­a EMT con 1 tablero de 6 circuitos, 1 toma VCP 220 V para acometida principal, 1 toma sencillo a 220 V, 4 tomas dobles a 110 V, 1 salida para voz y datos, 1 aire acondicionado de 12.000 BTU R410 a 220 V, iluminaciÃ³n con 2 lÃ¡mparas hermÃ©ticas de 2x32W y 1 interruptor sencillo. Recubrimiento en piso en vinilo PVC de alto trÃ¡fico, 1 puerta peatonal con chapa de seguridad y 2 ventanas corredizas de 1.00 x 1.00 m. Pintura en anticorrosivo para interior y exterior.\n\nValor mensual.\n\nTiempo mÃ­nimo de alquiler: 30 dÃ­as.",
                  cant: 8,
                  valorUnit: 580000,
                  valorBruto: 4640000,
                  dcto: 0,
                  iva: 19,
                  valorTotal: 5521600,
                },
                {
                  item: "Alquiler",
                  tipo: "20 Ft",
                  producto: "Oficina Tipo A",
                  descripcion:
                    "Alquiler de contenedor marÃ­timo de 20 pies.\nTipo oficina sin recubrimiento.\n\nIncluye: Red elÃ©ctrica expuesta en tuberÃ­a EMT con 1 tablero de 6 circuitos, 1 toma VCP 220 V para acometida principal, 1 toma sencillo a 220 V, 4 tomas dobles a 110 V, 1 salida para voz y datos, 1 aire acondicionado de 12.000 BTU R410 a 220 V, iluminaciÃ³n con 2 lÃ¡mparas hermÃ©ticas de 2x32W y 1 interruptor sencillo. Recubrimiento en piso en vinilo PVC de alto trÃ¡fico, 1 puerta peatonal con chapa de seguridad y 2 ventanas corredizas de 1.00 x 1.00 m. Pintura en anticorrosivo para interior y exterior.\n\nValor mensual.\n\nTiempo mÃ­nimo de alquiler: 30 dÃ­as.",
                  cant: 8,
                  valorUnit: 580000,
                  valorBruto: 4640000,
                  dcto: 0,
                  iva: 19,
                  valorTotal: 5521600,
                },
                {
                  item: "Alquiler",
                  tipo: "20 Ft",
                  producto: "Oficina Tipo A",
                  descripcion:
                    "Alquiler de contenedor marÃ­timo de 20 pies.\nTipo oficina sin recubrimiento.\n\nIncluye: Red elÃ©ctrica expuesta en tuberÃ­a EMT con 1 tablero de 6 circuitos, 1 toma VCP 220 V para acometida principal, 1 toma sencillo a 220 V, 4 tomas dobles a 110 V, 1 salida para voz y datos, 1 aire acondicionado de 12.000 BTU R410 a 220 V, iluminaciÃ³n con 2 lÃ¡mparas hermÃ©ticas de 2x32W y 1 interruptor sencillo. Recubrimiento en piso en vinilo PVC de alto trÃ¡fico, 1 puerta peatonal con chapa de seguridad y 2 ventanas corredizas de 1.00 x 1.00 m. Pintura en anticorrosivo para interior y exterior.\n\nValor mensual.\n\nTiempo mÃ­nimo de alquiler: 30 dÃ­as.",
                  cant: 8,
                  valorUnit: 580000,
                  valorBruto: 4640000,
                  dcto: 0,
                  iva: 19,
                  valorTotal: 5521600,
                },
                {
                  item: "Alquiler",
                  tipo: "20 Ft",
                  producto: "Oficina Tipo A",
                  descripcion:
                    "Alquiler de contenedor marÃ­timo de 20 pies.\n\nTipo oficina sin recubrimiento.\n\nIncluye: Red elÃ©ctrica expuesta en tuberÃ­a EMT con 1 tablero de 6 circuitos, 1 toma VCP 220 V para acometida principal, 1 toma sencillo a 220 V, 4 tomas dobles a 110 V, 1 salida para voz y datos, 1 aire acondicionado de 12.000 BTU R410 a 220 V, iluminaciÃ³n con 2 lÃ¡mparas hermÃ©ticas de 2x32W y 1 interruptor sencillo. Recubrimiento en piso en vinilo PVC de alto trÃ¡fico, 1 puerta peatonal con chapa de seguridad y 2 ventanas corredizas de 1.00 x 1.00 m. Pintura en anticorrosivo para interior y exterior.\n\nValor mensual.\n\nTiempo mÃ­nimo de alquiler: 30 dÃ­as.",
                  cant: 1,
                  valorUnit: 580000,
                  valorBruto: 580000,
                  dcto: 0,
                  iva: 19,
                  valorTotal: 690200,
                },
                {
                  item: "Alquiler",
                  tipo: "40 Ft HC",
                  producto: "Bodega",
                  descripcion:
                    "Alquiler de contenedor marÃ­timo de 40 pies.\n\nTipo Bodega.\n\nValor mes.\n\nTiempo mÃ­nimo de alquiler: 6 meses.",
                  cant: 1,
                  valorUnit: 639000,
                  valorBruto: 639000,
                  dcto: 0,
                  iva: 19,
                  valorTotal: 760410,
                },
                {
                  item: "Alquiler",
                  tipo: "40 Ft HC",
                  producto: "Bodega",
                  descripcion:
                    "Alquiler de contenedor marÃ­timo de 40 pies.\n\nTipo Bodega.\n\nValor mes.\n\nTiempo mÃ­nimo de alquiler: 6 meses.",
                  cant: 1,
                  valorUnit: 639000,
                  valorBruto: 639000,
                  dcto: 0,
                  iva: 19,
                  valorTotal: 760410,
                },
                {
                  item: "Alquiler",
                  tipo: "40 Ft HC",
                  producto: "Bodega",
                  descripcion:
                    "Alquiler de contenedor marÃ­timo de 40 pies.\n\nTipo Bodega.\n\nValor mes.\n\nTiempo mÃ­nimo de alquiler: 6 meses.",
                  cant: 1,
                  valorUnit: 639000,
                  valorBruto: 639000,
                  dcto: 0,
                  iva: 19,
                  valorTotal: 760410,
                },
                {
                  item: "Alquiler",
                  tipo: "40 Ft HC",
                  producto: "Bodega",
                  descripcion:
                    "Alquiler de contenedor marÃ­timo de 40 pies.\n\nTipo Bodega.\n\nValor mes.\n\nTiempo mÃ­nimo de alquiler: 6 meses.",
                  cant: 1,
                  valorUnit: 639000,
                  valorBruto: 639000,
                  dcto: 0,
                  iva: 19,
                  valorTotal: 760410,
                },
              ]}
            />
          </PDFViewer>
        </div>
      </Route> */}
      <Route path="/pdf">
        <div style={{ width: "100vw", height: "100vh" }}>
          <PDFViewer width="100%" height="100%">
            <Contract
              values_form={{
                client_name: "CONCESION LA PINTADA S.A.S",
                nit: "900740893",
                valor_canon_mes: 729000,
                valor_deposito: 510300,
                fecha_firma: "2022-02-17",
                municipio: "Tarso",
                camara_comercio: "Aguachica",
                representante_legal: "1212qw",
                id_representante_legal: 111,
                ciudad: "1111",
                ciudad_firma: "Amagá",
                cuenta_cobro: "1111",
                email_autorizado_cliente: "cesar@yopmail.com"
              }}
              data_service={[
                {
                  tipo: "20 Ft",
                  producto: "Grua Basculante",
                  valorTotal: 640000,
                },
                {
                  tipo: "20 Ft",
                  producto: "Grua Basculante",
                  valorTotal: 640000,
                },
              ]}
              data_detail={[
                {
                  item: "Alquiler",
                  tipo: "20 Ft",
                  producto: "Oficina Tipo B",
                  descripcion:
                    "Alquiler de contenedor marÃ­timo de 20 pies.\n\nTipo oficina OSB.\n\nIncluye: Red elÃ©ctrica con 1 tablero de 6 circuitos, 1 toma VCP 220 V para acometida principal, 1 toma sencillo a 220 V, 4 tomas dobles a 110 V, 1 salida para voz y datos, 1 aire acondicionado de 12.000 BTU R410 a 220 V, iluminaciÃ³n con panel LED redondo de 12 W y 1 interruptor sencillo. Recubrimiento en paredes con placa OSB, piso en vinilo PVC y cielo en placa PVC. 1 puerta peatonal con chapa de seguridad y 2 ventanas corredizas de 1.00 x 1.00 m. Pintura en anticorrosivo para exterior.\n\nValor mes.\n\nTiempo mÃ­nimo de alquiler: 30 dÃ­as.",
                  cant: 1,
                  valorUnit: 639000,
                  valorBruto: 639000,
                  dcto: 0,
                  iva: 19,
                  valorTotal: 760410,
                },
                {
                  item: "Alquiler",
                  tipo: "Mobiliario",
                  producto: "Puesto de Trabajo",
                  descripcion:
                    "Alquiler de puesto de trabajo.\n\nIncluye: 1 escritorio de 60 x 120 cm, 1 archivador metÃ¡lico de tres puestos, pata en H y 1 silla ejecutiva giratoria.\n\nValor mes.\n\nTiempo mÃ­nimo de alquiler: 30 dÃ­as.",
                  cant: 4,
                  valorUnit: 90000,
                  valorBruto: 360000,
                  dcto: 0,
                  iva: 19,
                  valorTotal: 428400,
                },
              ]}
              general_quote_data={{
                nro_cotizacion: "50"
              }}
            />
          </PDFViewer>
        </div>
      </Route>

      {/* <Route path="/pdf">
        <div style={{ width: "100vw", height: "100vh" }}>
          <PDFViewer width="100%" height="100%">
            <Remision
              data_tables={{
                table1: [
                  { col1: "Requerimiento N°", col2: 74 },
                  { col1: "Fecha", col2: "2021-07-06" },
                  { col1: "Cliente", col2: "STRACON INTERNATIONAL S.A.C." },
                  {
                    col1: "Destino (Ciudad)",
                    col2: "Buriticá, Antioquia, Colombia",
                  },
                  {
                    col1: "Origen (Ciudad)",
                    col2: "Girardota, Antioquia, Colombia",
                  },
                  { col1: "Dirección", col2: "Mina Continental Gold" },
                  { col1: "Responsable", col2: "Carlos Mario Velasquez" },
                  { col1: "Celular", col2: "3228586048" },
                ],
                table2: [
                  { col1: "Placas", col2: "ESP 886" },
                  { col1: "Conductor", col2: "Fabian Alfonso Medina" },
                  { col1: "Cédula", col2: 70327215 },
                  { col1: "Telefono", col2: "(318)294 29 85" },
                ],
                table3: [
                  { col1: "Tipo", col2: "20 Ft" },
                  { col1: "Referencia", col2: "FAMU 821967 - 8" },
                  {
                    col1: "Adiciones Entrega",
                    col2: "Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares OsorioCesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares OsorioCesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares OsorioCesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares OsorioCesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares OsorioCesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares OsorioCesar David Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares OsorioCesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio  Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio Cesar David Tabares Osorio ",
                  },
                  { col1: "Referencia", col2: "FAMU 821967 - 8" },
                ],
                remision: 2,
                tipo_remision: "Entrega",
                title: "REMISION No 2 STRACON INTERNATIONAL S.A.C.",
                user: "Juan Diego Jimenez Jimenez",
              }}
            />
          </PDFViewer>
        </div>
      </Route> */}

      {/* <Route path="/pdf">
        <div style={{ width: "100vw", height: "100vh" }}>
          <PDFViewer width="100%" height="100%">
            <Quote_pdf
              {...{
                nro_cot: 453,
                cliente: "STRACON INTERNATIONAL S.A.C.",
                contacto: "Luis",
                genero: "Masculino",
                nit: "900884289",
                fecha: "2021-05-25",
                table_data: [
                  {
                    no: 1,
                    item: "Venta",
                    tipo: "40 Ft HC",
                    producto: "Proyecto",
                    indexProducto: 5,
                    descripcion:
                      "Venta de contenedor marmo de 40 pies.\n\nAdaptado como alojamiento con 4 habitaciones con baÃ±o.\n\nCada habitaciÃ³n incluye: Red elÃ©ctrica con 2 tomas dobles 110V, 4 luminarias tipo ojo de buey de 3 W, 2 interruptores sencillos y 1 salida para TV. Recubrimiento en paredes en OSB, cielo en placa PVC y enchape para ducha, piso en vinilo PVC de alto trÃ¡fico, 1 ventana corrediza, puerta corrediza para baÃ±o y puerta en lamina de contenedor para exterior. Pintura exterior con anticorrosivo como base y esmalte como acabado.\n\nMobiliario:\n\n-1 camarote metÃ¡lico.\n-2 colchones Soft Flex Line 090x190x17cm o similar \n-1 sanitario corona Acuaplus ultra blanco o similar.\n-1 lavamanos colgar Corona Acuacer blanco con pedestal o similar.\n-1 ducha sencilla monocontrol.\n",
                    cant: 12,
                    valorUnit: 59910200,
                    valorBruto: 718922400,
                    dcto: 0,
                    iva: 19,
                    valorTotal: 855517656,
                  },
                  {
                    no: 2,
                    item: "Adaptacion",
                    tipo: "40 Ft HC",
                    producto: "Proyecto",
                    indexProducto: 0,
                    descripcion:
                      "AdaptaciÃ³n de contenedores mamo de 40 pies HC como Hospedaje. (3 pisos)\n\nIncluye: Escalera de acceso, pasillos, conexiones elÃ©ctricas e hidrosanitaria a punto cero.",
                    cant: 1,
                    valorUnit: 466136168,
                    valorBruto: 466136168,
                    dcto: 0,
                    iva: 19,
                    valorTotal: 554702039.92,
                  },
                ],
                subtotals: {
                  superBruto: 1185058568,
                  superDescuento: 0,
                  superSubtotal: 1185058568,
                  superIva: 225161127.92,
                  superTotal: 1410219695.92,
                },
                cargo: "Ejecutivo comercial",
                nombre_vendedor: "Juan Diego Jiménez",
                celular: "3022382922",
                email: "gerencia@contenedoresdeantioquia.com",
                observaciones:
                  "Nosotros prestamos un servicio logístico. Cotización valida por 15 días. ALQUILER: La forma de pago es mes anticipado, al inicio se cobra un canon adicional correspondiente al 70% del valor del alquiler (Deposito de Garantías), monto que será devuelto en el momento que se devuelvan los ítems alquilados en las mismas condiciones en las que fueron entregados. VENTA: Se debe hacer un anticipo del 60% para dar inicio a las adecuaciones que sean requeridas, y se debe pagar el monto restante previo a la entrega, de lo contrario el contenedor no podrá ser despachado. TRANSPORTE: El valor estipulado en esta cotización se mantendrá si y solo si se recibe el contenedor dentro del plazo de tiempo establecido y acordado, en caso de haber retrasos en la recepción de éste, y se generen sobre costos, se deberá hacer un ajuste en el cobro del transporte desde $70.000 hasta $180.000 (dependiendo del tipo de transporte) por cada hora adicional. ALMACENAMIENTO: En caso de que el cliente no pueda recibir el producto o proyecto en los tiempos establecidos, se le darán 5 días corridos para recibirlo como gabela. Cumplido este periodo de tiempo se le cobrará el espació en patios correspondiente a una tarifa que va desde los $15.000 hasta los $30.000 por día de almacenamiento, dependiendo del tamaño. CONDICIONES: En caso de retractarse de algún contrato o pago generado, y de solicitar una devolución, se descontará el 5% sobre el pago hecho, por gastos administrativos. Esta cotización NO incluye póliza, en caso de ser requerida se le sumará a la cotización. Sujetos a disponibilidad.",
                encabezado:
                  "Reciba un cordial saludo, espero se encuentre muy bien. A continuaciÃ³n, detallo la propuesta comercial segÃºn su requerimiento.\n\nNota: Una vez se revise la ubicaciÃ³n del proyecto se aterriza mas la cotizaciÃ³n.\n\n Se trabaja como base el diseÃ±o de Hoteles BlockÂ®, tratando de optimizar acabados para reducir costos.\n\nSi desea conocer mÃ¡s acerca de nosotros, haga click en cualquiera de los iconos correspondientes a nuestras redes. \n",
              }}
            />
          </PDFViewer>
        </div>
      </Route> */}
      {/* <Route path="/pdf">
        <div style={{ width: "100vw", height: "100vh" }}>
          <PDFViewer width="100%" height="100%">
            <PoPdf
              dataOp={{
                supplierName: "Turinng SAS",
                governmentId: "11111111111111111",
                phone: "1111111111",
                email: "info@turinng.com",
                address: "sample address 123",
                paymentMethod: 11,
                paymentTerm: 22,
                autoRetainer: true,
                deliveryAdress: "sample address 123",
                buyerName: "Loza",
                deliveryDate: "2022-02-17",
                discountPercentage: 10,
                poId: 10,
                discount: 0,
                retention: 2.5,
                iva: 19, 
                buyerPhone: "(311) 790 36 30",
                observations: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Tempore voluptatibus maiores blanditiis libero saepe consequatur porro facilis alias consequuntur vitae ipsam tempora quidem aliquid deleniti odio a quos, ad amet!",
                items: [
                  {
                    id: 30,
                    product_code: "1111111",
                    description: "aaaaa",
                    order_id: 10,
                    unit: "und",
                    quantity: 13,
                    price: "10.000",
                    iva: 0.1,
                  },
                  

                ]
                  ,
          }}
            />
          </PDFViewer>
        </div>
      </Route> */}
      {/* <Route path="/pdf">
        <div style={{ width: "100vw", height: "100vh" }}>
          <PDFViewer width="100%" height="100%">
            <OrderPdf
              dataOp={{
                type: "Venta Producto",
                orderName: "Orden de Venta BLA BLA BLA",
                orderDate: "2024-06-06",
                orderNumber: "PI123456",
                b64barcode: "data:image/png;base64,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",
                items: [
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
{
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },
                  {
                    id: 30,
                    code: "1111111",
                    description: "aas dlsfjinf lihjsbnd flihsbd lfihsb dflihsbd lfhsvbd lfh sdlifybs ldifvb sluidyfvs l;idhfb s;idufb s;idufb ;siudbf ;sioudbf ;sodufb s;idufb pi;uyvb ",
                    unit: "und",
                    quantity: 13,
                  },

                  

                ]
          }}
            />
          </PDFViewer>
        </div>
      </Route> */}
    </Switch>
  );
}

export default Routes;
